<template>
  <main class="main">
    <div class="anim-wrap" :class="{ loading: loading }">
      <div class="container" v-if="sessionData">
        <div class="row page-nav" v-if="getUser">
          <div class="col-md-8 hidden-sm"></div>
          <div class="col-md-4 text-md-right">
            <a href="#" @click="$router.go(-1)" class="link-item"
              ><font-awesome-icon icon="angle-left" /> Back</a
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center py-5 mb-5">
            <h1>Welcome to Traitstack</h1>
            <h4>{{ sessionData.groupName }}</h4>
          </div>
        </div>
        <div v-if="!completedTests" class="row mb-4">
          <div class="col-md-10 offset-md-1">
            <div class="panel panel-info">
              <div class="row">
                <div class="col-md-1 text-center">
                  <font-awesome-icon class="icon-large" icon="info-circle" />
                </div>
                <div class="col-md-10">
                  <p>
                    You have been invited to participate in
                    <strong>{{ sessionData.groupName }}</strong
                    >. Complete the individual assignments below. Your group
                    admin will be automatically notified once the assignments
                    have been completed.
                  </p>
                  <p v-if="sessionData.adminEmail">
                    If you have any questions, you can email
                    <strong>{{ sessionData.adminEmail }}</strong
                    >.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row mb-2">
          <div class="col-md-10 offset-md-1">
            <b-alert class="p-5" show variant="success">
              <h4 class="alert-heading">Tests completed!</h4>
              <p>
                You have successfully completed the assignments.
                <span v-if="sessionData.reportAccess"
                  >You can view your scores by clicking the "View results"
                  button.</span
                >
              </p>
              <p v-if="sessionData.adminEmail">
                If you have any questions, you can email
                <strong>{{ sessionData.adminEmail }}</strong
                >.
              </p>
            </b-alert>
          </div>
        </div>
        <div class="row" v-if="this.sessionData.includeInsights">
          <div class="col-md-10 offset-md-1">
            <div class="panel panel-content pad-medium">
              <div class="row assessment-module">
                <div class="col-md-3 text-center">
                  <img
                    src="/static/img/icon_personality.svg"
                    class="svg-image"
                    alt
                  />
                </div>
                <div class="col-md-9">
                  <h2>
                    Insights
                    <b-badge
                      v-if="!this.sessionData.completedInsights"
                      pill
                      class="pill-med"
                      variant="light"
                      ><font-awesome-icon :icon="['far', 'clock']" /> Not
                      complete</b-badge
                    >
                    <b-badge v-else pill class="pill-med" variant="success"
                      ><font-awesome-icon :icon="['fas', 'check']" />
                      Completed</b-badge
                    >
                  </h2>
                  <p>
                    Each one of us is unique and interesting. What does your
                    personality look like? Find out your strenghts and
                    orientations.
                  </p>
                  <p><strong>Duration: approximately 10min</strong></p>
                  <router-link
                    v-if="!this.sessionData.completedInsights"
                    class="btn btn-primary"
                    :to="{ name: 'testpersonality', params: { code: code } }"
                    >Start test</router-link
                  >
                  <router-link
                    v-if="
                      this.sessionData.completedInsights &&
                        this.sessionData.reportAccess
                    "
                    class="btn btn-secondary"
                    :to="'/results/insights/?id=' + code"
                    >View results</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="this.sessionData.includePathways">
          <div class="col-md-10 offset-md-1">
            <div class="panel panel-content pad-medium">
              <div class="row assessment-module">
                <div class="col-md-3 text-center">
                  <img
                    src="/static/img/icon_workforce.svg"
                    class="svg-image"
                    alt
                  />
                </div>
                <div class="col-md-9">
                  <h2>
                    Pathways
                    <b-badge
                      v-if="!this.sessionData.completedPathways"
                      pill
                      class="pill-med"
                      variant="light"
                      ><font-awesome-icon :icon="['far', 'clock']" /> Not
                      complete</b-badge
                    >
                    <b-badge v-else pill class="pill-med" variant="success"
                      ><font-awesome-icon :icon="['fas', 'check']" />
                      Completed</b-badge
                    >
                  </h2>
                  <p>
                    Our interests and motivations inform the types of tasks we
                    prefer to spend time on. Find your perfect career fit, the
                    training requirements, average salary, tasks, and demand.
                  </p>
                  <p><strong>Duration: approximately 5min</strong></p>
                  <router-link
                    v-if="!this.sessionData.completedPathways"
                    class="btn btn-primary"
                    :to="{ name: 'testpathways', params: { code: code } }"
                    >Start test</router-link
                  >
                  <router-link
                    v-if="
                      this.sessionData.completedPathways &&
                        this.sessionData.reportAccess
                    "
                    class="btn btn-secondary"
                    :to="'/results/pathways/?id=' + code"
                    >View results</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-if="loadError">
        <div class="panel panel-flat text-center">
          <h1>Error</h1>
          <p>
            The invite has either expired or the link is malformed. Please check
            and verify the link.
          </p>
          <p>
            If the problem keeps occuring, get in touch with your group admin.
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { mapState } from "vuex";
import SVGInjector from "svg-injector";

export default {
  name: "hub",
  components: {},
  data() {
    return {
      loadError: false,
      loading: false,
      sessionData: null,
      code: null,
    };
  },
  computed: {
    ...mapState(["user"]),
    getUser() {
      return this.user ? this.user : "";
    },
    completedTests() {
      let complete = true;
      if (this.sessionData) {
        if (
          this.sessionData.includePathways &&
          !this.sessionData.completedPathways
        ) {
          complete = false;
        }
        if (
          this.sessionData.includeInsights &&
          !this.sessionData.completedInsights
        ) {
          complete = false;
        }
      }
      return complete;
    },
  },
  mounted() {
    this.code = this.$route.query.code;
    this.getSessionData();
  },
  methods: {
    getSessionData() {
      if (!this.code) {
        return false;
      }
      this.loadError = false;
      this.loading = true;
      let getSessionData = firebase.functions().httpsCallable("getSessionData");

      getSessionData({
        code: this.code,
      })
        .then((result) => {
          this.loading = false;
          this.sessionData = result.data;
          this.$nextTick(() => {
            var mySVGsToInject = document.querySelectorAll(".svg-image");
            SVGInjector(mySVGsToInject);
          });
        })
        .catch((error) => {
          this.loading = false;
          this.loadError = true;
          console.log(error);
        });
    },
  },
};
</script>
